import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setCompanyProduct } from 'services/api/AccessManagerAPI';
import { queryKeys } from '../queryKeys';

// Switches a product on or off for a company (SLAI staff). Refetches the
// companies, and the member lists: what a caller manages follows the
// company's products.
export const useSetCompanyProduct = () => {
    const queryClient = useQueryClient();
    const { mutateAsync, isPending } = useMutation({
        mutationFn: setCompanyProduct,
        retry: false,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.companies });
            queryClient.invalidateQueries({ queryKey: ['members'] });
        },
    });
    return { setCompanyProduct: mutateAsync, isPending };
};
